var _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _path9, _path0, _g4, _path1, _path10, _g5, _path11, _path12, _path13, _g6, _path14, _path15, _g7, _path16, _path17, _path18, _g8, _path19, _path20, _g9, _path21, _path22, _path23, _g0, _path24, _path25, _g1, _path26, _path27, _path28, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopImgCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 108,
    viewBox: "0 0 360 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.416 -25.8378L-63.8929 22.7034C-68.3628 25.277 -69.5391 31.5904 -66.5202 36.8047L-33.9518 93.0589C-30.933 98.2732 -24.8621 100.414 -20.3922 97.8405L63.9166 49.2993C68.3865 46.7257 69.5628 40.4123 66.5439 35.198L33.9756 -21.0562C30.9567 -26.2705 24.8859 -28.4113 20.416 -25.8378Z",
    fill: "url(#paint0_linear_4330_50313)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4330_50313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -69,
    y: -27,
    width: 138,
    height: 126
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.416 -25.8378L-63.8929 22.7034C-68.3628 25.277 -69.5391 31.5904 -66.5202 36.8047L-33.9518 93.0589C-30.933 98.2732 -24.8621 100.414 -20.3922 97.8405L63.9166 49.2993C68.3865 46.7257 69.5628 40.4123 66.5439 35.198L33.9756 -21.0562C30.9567 -26.2705 24.8859 -28.4113 20.416 -25.8378Z",
    fill: "url(#paint1_linear_4330_50313)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4330_50313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.01128 51.4258L-16.6242 46.0581C-17.6913 45.7805 -18.796 46.4183 -19.0891 47.4812L-21.4248 55.9514L-9.29384 59.1076C-8.22675 59.3852 -7.59817 60.4739 -7.89128 61.5369L-8.88505 65.1407L-0.381774 67.353C0.68531 67.6306 1.79 66.9928 2.08311 65.9299L5.41258 53.8559C5.70569 52.7929 5.07711 51.7042 4.01002 51.4266L4.01128 51.4258Z",
    fill: "#74D400"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-57.4152 52.5704L-65.0083 39.4521L35.5239 -18.4425L43.1171 -5.3243L-57.4152 52.5704Z",
    fill: "url(#paint2_linear_4330_50313)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-57.4152 52.5704L-65.0083 39.4521L35.5239 -18.4425L43.1171 -5.3243L-57.4152 52.5704Z",
    fill: "url(#paint3_linear_4330_50313)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-57.4152 52.5704L-65.0083 39.4521L35.5239 -18.4425L43.1171 -5.3243L-57.4152 52.5704Z",
    fill: "url(#paint4_linear_4330_50313)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4330_50313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3825 27.0987L41.0778 31.3044C39.5881 32.1621 39.196 34.2662 40.2022 36.0041L45.1356 44.5254C46.1417 46.2633 48.1651 46.9767 49.6548 46.119L56.9595 41.9133C58.4493 41.0556 58.8413 38.9514 57.8352 37.2136L52.9018 28.6923C51.8956 26.9544 49.8723 26.2409 48.3825 27.0987Z",
    fill: "url(#paint5_linear_4330_50313)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4436 -25.8378L8.13474 22.7034C3.66483 25.277 2.48853 31.5904 5.50738 36.8047L38.0758 93.0589C41.0946 98.2732 47.1654 100.414 51.6354 97.8405L135.944 49.2993C140.414 46.7257 141.59 40.4123 138.572 35.198L106.003 -21.0562C102.984 -26.2705 96.9135 -28.4113 92.4436 -25.8378Z",
    fill: "url(#paint6_linear_4330_50313)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4330_50313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: -27,
    width: 138,
    height: 126
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4436 -25.8378L8.13474 22.7034C3.66483 25.277 2.48853 31.5904 5.50738 36.8047L38.0758 93.0589C41.0946 98.2732 47.1654 100.414 51.6354 97.8405L135.944 49.2993C140.414 46.7257 141.59 40.4123 138.572 35.198L106.003 -21.0562C102.984 -26.2705 96.9135 -28.4113 92.4436 -25.8378Z",
    fill: "url(#paint7_linear_4330_50313)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4330_50313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5085 74.0225L42.1039 72.0991C40.8296 73.9327 40.6319 76.3873 41.8092 78.4265C43.4413 81.2533 47.0906 82.2027 49.9588 80.5468C52.0279 79.3522 53.1197 77.1303 52.9588 74.9222L49.5092 74.0237L49.5085 74.0225Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.68 63.1866C48.9487 62.7362 47.9267 60.966 48.4023 59.2415L49.3966 55.6357L42.0994 53.7393C41.5991 53.6133 41.0864 53.6855 40.6565 53.9041C40.1684 54.1579 39.7907 54.5998 39.6363 55.1597L37.3002 63.635L36.3018 67.2366C36.0121 68.3025 36.6385 69.3875 37.7065 69.6696L49.8405 72.8223L58.3427 75.0386C59.4128 75.3128 60.5138 74.6772 60.8113 73.6133L62.8129 66.3433L50.68 63.1866Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0389 51.4258L55.4034 46.0581C54.3363 45.7805 53.2316 46.4183 52.9385 47.4812L50.6028 55.9514L62.7337 59.1076C63.8008 59.3852 64.4294 60.4739 64.1363 61.5369L63.1425 65.1407L71.6458 67.353C72.7129 67.6306 73.8176 66.9928 74.1107 65.9299L77.4402 53.8559C77.7333 52.7929 77.1047 51.7042 76.0376 51.4266L76.0389 51.4258Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7337 59.1075L50.6028 55.9514L49.609 59.5552C49.3159 60.6181 49.9445 61.7069 51.0116 61.9845L63.1425 65.1407L64.1363 61.5369C64.4294 60.4739 63.8008 59.3852 62.7337 59.1075Z",
    fill: "#74D400"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6124 52.5704L7.01929 39.4521L107.552 -18.4425L115.145 -5.3243L14.6124 52.5704Z",
    fill: "url(#paint8_linear_4330_50313)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6124 52.5704L7.01929 39.4521L107.552 -18.4425L115.145 -5.3243L14.6124 52.5704Z",
    fill: "url(#paint9_linear_4330_50313)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6124 52.5704L7.01929 39.4521L107.552 -18.4425L115.145 -5.3243L14.6124 52.5704Z",
    fill: "url(#paint10_linear_4330_50313)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dii_4330_50313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.41 27.0987L113.105 31.3044C111.616 32.1621 111.224 34.2662 112.23 36.0041L117.163 44.5254C118.169 46.2633 120.193 46.9767 121.682 46.119L128.987 41.9133C130.477 41.0556 130.869 38.9514 129.863 37.2136L124.929 28.6923C123.923 26.9544 121.9 26.2409 120.41 27.0987Z",
    fill: "url(#paint11_linear_4330_50313)"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M164.471 -25.8378L80.1621 22.7034C75.6922 25.277 74.5159 31.5904 77.5347 36.8047L110.103 93.0589C113.122 98.2732 119.193 100.414 123.663 97.8405L207.972 49.2993C212.441 46.7257 213.618 40.4123 210.599 35.198L178.031 -21.0562C175.012 -26.2705 168.941 -28.4113 164.471 -25.8378Z",
    fill: "url(#paint12_linear_4330_50313)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4330_50313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: -27,
    width: 138,
    height: 126
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164.471 -25.8378L80.1621 22.7034C75.6922 25.277 74.5159 31.5904 77.5347 36.8047L110.103 93.0589C113.122 98.2732 119.193 100.414 123.663 97.8405L207.972 49.2993C212.441 46.7257 213.618 40.4123 210.599 35.198L178.031 -21.0562C175.012 -26.2705 168.941 -28.4113 164.471 -25.8378Z",
    fill: "url(#paint13_linear_4330_50313)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4330_50313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.536 74.0225L114.131 72.0991C112.857 73.9327 112.659 76.3873 113.837 78.4265C115.469 81.2533 119.118 82.2027 121.986 80.5468C124.055 79.3522 125.147 77.1303 124.986 74.9222L121.537 74.0237L121.536 74.0225Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.707 63.1866C120.976 62.7362 119.954 60.966 120.43 59.2415L121.424 55.6357L114.127 53.7393C113.626 53.6133 113.114 53.6855 112.684 53.9041C112.196 54.1579 111.818 54.5998 111.664 55.1597L109.328 63.635L108.329 67.2366C108.039 68.3025 108.666 69.3875 109.734 69.6696L121.868 72.8223L130.37 75.0386C131.44 75.3128 132.541 74.6772 132.839 73.6133L134.84 66.3433L122.707 63.1866Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.066 51.4258L127.431 46.0581C126.364 45.7805 125.259 46.4183 124.966 47.4812L122.63 55.9514L134.761 59.1076C135.828 59.3852 136.457 60.4739 136.164 61.5369L135.17 65.1407L143.673 67.353C144.74 67.6306 145.845 66.9928 146.138 65.9299L149.468 53.8559C149.761 52.7929 149.132 51.7042 148.065 51.4266L148.066 51.4258Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.761 59.1075L122.63 55.9514L121.636 59.5552C121.343 60.6181 121.972 61.7069 123.039 61.9845L135.17 65.1407L136.164 61.5369C136.457 60.4739 135.828 59.3852 134.761 59.1075Z",
    fill: "#74D400"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6397 52.5704L79.0466 39.4521L179.579 -18.4425L187.172 -5.3243L86.6397 52.5704Z",
    fill: "url(#paint14_linear_4330_50313)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6397 52.5704L79.0466 39.4521L179.579 -18.4425L187.172 -5.3243L86.6397 52.5704Z",
    fill: "url(#paint15_linear_4330_50313)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6397 52.5704L79.0466 39.4521L179.579 -18.4425L187.172 -5.3243L86.6397 52.5704Z",
    fill: "url(#paint16_linear_4330_50313)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dii_4330_50313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.437 27.0987L185.133 31.3044C183.643 32.1621 183.251 34.2662 184.257 36.0041L189.191 44.5254C190.197 46.2633 192.22 46.9767 193.71 46.119L201.014 41.9133C202.504 41.0556 202.896 38.9514 201.89 37.2136L196.957 28.6923C195.951 26.9544 193.927 26.2409 192.437 27.0987Z",
    fill: "url(#paint17_linear_4330_50313)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M236.498 -25.8378L152.19 22.7034C147.72 25.277 146.543 31.5904 149.562 36.8047L182.131 93.0589C185.15 98.2732 191.22 100.414 195.69 97.8405L279.999 49.2993C284.469 46.7257 285.645 40.4123 282.626 35.198L250.058 -21.0562C247.039 -26.2705 240.968 -28.4113 236.498 -25.8378Z",
    fill: "url(#paint18_linear_4330_50313)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4330_50313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: -27,
    width: 138,
    height: 126
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M236.498 -25.8378L152.19 22.7034C147.72 25.277 146.543 31.5904 149.562 36.8047L182.131 93.0589C185.15 98.2732 191.22 100.414 195.69 97.8405L279.999 49.2993C284.469 46.7257 285.645 40.4123 282.626 35.198L250.058 -21.0562C247.039 -26.2705 240.968 -28.4113 236.498 -25.8378Z",
    fill: "url(#paint19_linear_4330_50313)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4330_50313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.563 74.0225L186.159 72.0991C184.885 73.9327 184.687 76.3873 185.864 78.4265C187.496 81.2533 191.146 82.2027 194.014 80.5468C196.083 79.3522 197.175 77.1303 197.014 74.9222L193.564 74.0237L193.563 74.0225Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.735 63.1866C193.004 62.7362 191.982 60.966 192.457 59.2415L193.451 55.6357L186.154 53.7393C185.654 53.6133 185.141 53.6855 184.711 53.9041C184.223 54.1579 183.846 54.5998 183.691 55.1597L181.355 63.635L180.357 67.2366C180.067 68.3025 180.693 69.3875 181.761 69.6696L193.895 72.8223L202.398 75.0386C203.468 75.3128 204.569 74.6772 204.866 73.6133L206.868 66.3433L194.735 63.1866Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.094 51.4258L199.458 46.0581C198.391 45.7805 197.287 46.4183 196.993 47.4812L194.658 55.9514L206.789 59.1076C207.856 59.3852 208.484 60.4739 208.191 61.5369L207.197 65.1407L215.701 67.353C216.768 67.6306 217.873 66.9928 218.166 65.9299L221.495 53.8559C221.788 52.7929 221.16 51.7042 220.093 51.4266L220.094 51.4258Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.789 59.1075L194.658 55.9514L193.664 59.5552C193.371 60.6181 193.999 61.7069 195.066 61.9845L207.197 65.1407L208.191 61.5369C208.484 60.4739 207.856 59.3852 206.789 59.1075Z",
    fill: "#74D400"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.667 52.5704L151.074 39.4521L251.606 -18.4425L259.2 -5.3243L158.667 52.5704Z",
    fill: "url(#paint20_linear_4330_50313)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.667 52.5704L151.074 39.4521L251.606 -18.4425L259.2 -5.3243L158.667 52.5704Z",
    fill: "url(#paint21_linear_4330_50313)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158.667 52.5704L151.074 39.4521L251.606 -18.4425L259.2 -5.3243L158.667 52.5704Z",
    fill: "url(#paint22_linear_4330_50313)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dii_4330_50313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.465 27.0987L257.16 31.3044C255.671 32.1621 255.279 34.2662 256.285 36.0041L261.218 44.5254C262.224 46.2633 264.248 46.9767 265.737 46.119L273.042 41.9133C274.532 41.0556 274.924 38.9514 273.918 37.2136L268.984 28.6923C267.978 26.9544 265.955 26.2409 264.465 27.0987Z",
    fill: "url(#paint23_linear_4330_50313)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M308.526 -25.8378L224.217 22.7034C219.747 25.277 218.571 31.5904 221.59 36.8047L254.158 93.0589C257.177 98.2732 263.248 100.414 267.718 97.8405L352.026 49.2993C356.496 46.7257 357.673 40.4123 354.654 35.198L322.085 -21.0562C319.067 -26.2705 312.996 -28.4113 308.526 -25.8378Z",
    fill: "url(#paint24_linear_4330_50313)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4330_50313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 219,
    y: -27,
    width: 138,
    height: 126
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M308.526 -25.8378L224.217 22.7034C219.747 25.277 218.571 31.5904 221.59 36.8047L254.158 93.0589C257.177 98.2732 263.248 100.414 267.718 97.8405L352.026 49.2993C356.496 46.7257 357.673 40.4123 354.654 35.198L322.085 -21.0562C319.067 -26.2705 312.996 -28.4113 308.526 -25.8378Z",
    fill: "url(#paint25_linear_4330_50313)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4330_50313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.591 74.0225L258.186 72.0991C256.912 73.9327 256.714 76.3873 257.891 78.4265C259.524 81.2533 263.173 82.2027 266.041 80.5468C268.11 79.3522 269.202 77.1303 269.041 74.9222L265.591 74.0237L265.591 74.0225Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.762 63.1866C265.031 62.7362 264.009 60.966 264.485 59.2415L265.479 55.6357L258.182 53.7393C257.681 53.6133 257.169 53.6855 256.739 53.9041C256.251 54.1579 255.873 54.5998 255.719 55.1597L253.382 63.635L252.384 67.2366C252.094 68.3025 252.721 69.3875 253.789 69.6696L265.923 72.8223L274.425 75.0386C275.495 75.3128 276.596 74.6772 276.894 73.6133L278.895 66.3433L266.762 63.1866Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.121 51.4258L271.486 46.0581C270.419 45.7805 269.314 46.4183 269.021 47.4812L266.685 55.9514L278.816 59.1076C279.883 59.3852 280.512 60.4739 280.219 61.5369L279.225 65.1407L287.728 67.353C288.795 67.6306 289.9 66.9928 290.193 65.9299L293.522 53.8559C293.816 52.7929 293.187 51.7042 292.12 51.4266L292.121 51.4258Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.816 59.1075L266.685 55.9514L265.691 59.5552C265.398 60.6181 266.027 61.7069 267.094 61.9845L279.225 65.1407L280.219 61.5369C280.512 60.4739 279.883 59.3852 278.816 59.1075Z",
    fill: "#74D400"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M230.695 52.5704L223.102 39.4521L323.634 -18.4425L331.227 -5.3243L230.695 52.5704Z",
    fill: "url(#paint26_linear_4330_50313)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M230.695 52.5704L223.102 39.4521L323.634 -18.4425L331.227 -5.3243L230.695 52.5704Z",
    fill: "url(#paint27_linear_4330_50313)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M230.695 52.5704L223.102 39.4521L323.634 -18.4425L331.227 -5.3243L230.695 52.5704Z",
    fill: "url(#paint28_linear_4330_50313)"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dii_4330_50313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.492 27.0987L329.188 31.3044C327.698 32.1621 327.306 34.2662 328.312 36.0041L333.245 44.5254C334.252 46.2633 336.275 46.9767 337.765 46.119L345.069 41.9133C346.559 41.0556 346.951 38.9514 345.945 37.2136L341.012 28.6923C340.005 26.9544 337.982 26.2409 336.492 27.0987Z",
    fill: "url(#paint29_linear_4330_50313)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M380.553 -25.8378L296.245 22.7034C291.775 25.277 290.598 31.5904 293.617 36.8047L326.186 93.0589C329.204 98.2732 335.275 100.414 339.745 97.8405L424.054 49.2993C428.524 46.7257 429.7 40.4123 426.681 35.198L394.113 -21.0562C391.094 -26.2705 385.023 -28.4113 380.553 -25.8378Z",
    fill: "url(#paint30_linear_4330_50313)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4330_50313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 291,
    y: -27,
    width: 138,
    height: 126
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M380.553 -25.8378L296.245 22.7034C291.775 25.277 290.598 31.5904 293.617 36.8047L326.186 93.0589C329.204 98.2732 335.275 100.414 339.745 97.8405L424.054 49.2993C428.524 46.7257 429.7 40.4123 426.681 35.198L394.113 -21.0562C391.094 -26.2705 385.023 -28.4113 380.553 -25.8378Z",
    fill: "url(#paint31_linear_4330_50313)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4330_50313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.618 74.0225L330.214 72.0991C328.939 73.9327 328.742 76.3873 329.919 78.4265C331.551 81.2533 335.2 82.2027 338.069 80.5468C340.138 79.3522 341.23 77.1303 341.069 74.9222L337.619 74.0237L337.618 74.0225Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.79 63.1866C337.059 62.7362 336.037 60.966 336.512 59.2415L337.506 55.6357L330.209 53.7393C329.709 53.6133 329.196 53.6855 328.766 53.9041C328.278 54.1579 327.901 54.5998 327.746 55.1597L325.41 63.635L324.412 67.2366C324.122 68.3025 324.748 69.3875 325.816 69.6696L337.95 72.8223L346.453 75.0386C347.523 75.3128 348.624 74.6772 348.921 73.6133L350.923 66.3433L338.79 63.1866Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.149 51.4258L343.513 46.0581C342.446 45.7805 341.341 46.4183 341.048 47.4812L338.713 55.9514L350.844 59.1076C351.911 59.3852 352.539 60.4739 352.246 61.5369L351.252 65.1407L359.756 67.353C360.823 67.6306 361.927 66.9928 362.221 65.9299L365.55 53.8559C365.843 52.7929 365.215 51.7042 364.147 51.4266L364.149 51.4258Z",
    fill: "#74D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.844 59.1075L338.713 55.9514L337.719 59.5552C337.426 60.6181 338.054 61.7069 339.121 61.9845L351.252 65.1407L352.246 61.5369C352.539 60.4739 351.911 59.3852 350.844 59.1075Z",
    fill: "#74D400"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M302.722 52.5704L295.129 39.4521L395.661 -18.4425L403.255 -5.3243L302.722 52.5704Z",
    fill: "url(#paint32_linear_4330_50313)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M302.722 52.5704L295.129 39.4521L395.661 -18.4425L403.255 -5.3243L302.722 52.5704Z",
    fill: "url(#paint33_linear_4330_50313)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M302.722 52.5704L295.129 39.4521L395.661 -18.4425L403.255 -5.3243L302.722 52.5704Z",
    fill: "url(#paint34_linear_4330_50313)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4330_50313",
    x: 39.3943,
    y: 26.6354,
    width: 19.0488,
    height: 20.0471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.596078 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4330_50313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4330_50313",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.05,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.905882 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4330_50313"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.05,
    dy: -0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.694118 0 0 0 0 0.2 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_4330_50313",
    result: "effect3_innerShadow_4330_50313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dii_4330_50313",
    x: 111.422,
    y: 26.6354,
    width: 19.0488,
    height: 20.0471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.596078 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4330_50313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4330_50313",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.05,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.905882 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4330_50313"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.05,
    dy: -0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.694118 0 0 0 0 0.2 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_4330_50313",
    result: "effect3_innerShadow_4330_50313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dii_4330_50313",
    x: 183.449,
    y: 26.6354,
    width: 19.0488,
    height: 20.0471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.596078 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4330_50313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4330_50313",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.05,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.905882 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4330_50313"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.05,
    dy: -0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.694118 0 0 0 0 0.2 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_4330_50313",
    result: "effect3_innerShadow_4330_50313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dii_4330_50313",
    x: 255.477,
    y: 26.6354,
    width: 19.0488,
    height: 20.0471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.596078 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4330_50313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4330_50313",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.05,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.905882 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4330_50313"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.05,
    dy: -0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.694118 0 0 0 0 0.2 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_4330_50313",
    result: "effect3_innerShadow_4330_50313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dii_4330_50313",
    x: 327.504,
    y: 26.6354,
    width: 19.0488,
    height: 20.0471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.596078 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4330_50313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4330_50313",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.05,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.905882 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4330_50313"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.05,
    dy: -0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.694118 0 0 0 0 0.2 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_4330_50313",
    result: "effect3_innerShadow_4330_50313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4330_50313",
    x1: -21.7384,
    y1: -1.56717,
    x2: 19.6173,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4330_50313",
    x1: -21.7384,
    y1: -1.56717,
    x2: 19.6173,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4330_50313",
    x1: -59.6166,
    y1: 48.7671,
    x2: 40.7839,
    y2: -9.34695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D476D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3D3B3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4330_50313",
    x1: -60.2702,
    y1: 47.6379,
    x2: -54.8653,
    y2: 44.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#513E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#513E5F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4330_50313",
    x1: 40.6083,
    y1: -9.65019,
    x2: 38.1359,
    y2: -8.21907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#474646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474646",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4330_50313",
    x1: 54.4952,
    y1: 31.4446,
    x2: 44.1694,
    y2: 37.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4330_50313",
    x1: 50.2891,
    y1: -1.56717,
    x2: 91.6449,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4330_50313",
    x1: 50.2891,
    y1: -1.56717,
    x2: 91.6449,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4330_50313",
    x1: 12.411,
    y1: 48.7671,
    x2: 112.811,
    y2: -9.34695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D476D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3D3B3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4330_50313",
    x1: 11.7574,
    y1: 47.6379,
    x2: 17.1623,
    y2: 44.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#513E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#513E5F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4330_50313",
    x1: 112.636,
    y1: -9.65019,
    x2: 110.163,
    y2: -8.21907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#474646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474646",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4330_50313",
    x1: 126.523,
    y1: 31.4446,
    x2: 116.197,
    y2: 37.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4330_50313",
    x1: 122.316,
    y1: -1.56717,
    x2: 163.672,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4330_50313",
    x1: 122.316,
    y1: -1.56717,
    x2: 163.672,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4330_50313",
    x1: 84.4384,
    y1: 48.7671,
    x2: 184.839,
    y2: -9.34695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D476D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3D3B3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4330_50313",
    x1: 83.7847,
    y1: 47.6379,
    x2: 89.1896,
    y2: 44.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#513E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#513E5F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4330_50313",
    x1: 184.663,
    y1: -9.65019,
    x2: 182.191,
    y2: -8.21907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#474646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474646",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4330_50313",
    x1: 198.55,
    y1: 31.4446,
    x2: 188.224,
    y2: 37.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4330_50313",
    x1: 194.344,
    y1: -1.56717,
    x2: 235.7,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4330_50313",
    x1: 194.344,
    y1: -1.56717,
    x2: 235.7,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4330_50313",
    x1: 156.466,
    y1: 48.7671,
    x2: 256.866,
    y2: -9.34695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D476D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3D3B3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4330_50313",
    x1: 155.812,
    y1: 47.6379,
    x2: 161.217,
    y2: 44.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#513E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#513E5F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4330_50313",
    x1: 256.691,
    y1: -9.65019,
    x2: 254.218,
    y2: -8.21907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#474646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474646",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4330_50313",
    x1: 270.578,
    y1: 31.4446,
    x2: 260.252,
    y2: 37.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4330_50313",
    x1: 266.371,
    y1: -1.56717,
    x2: 307.727,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4330_50313",
    x1: 266.371,
    y1: -1.56717,
    x2: 307.727,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4330_50313",
    x1: 228.493,
    y1: 48.7671,
    x2: 328.894,
    y2: -9.34695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D476D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3D3B3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4330_50313",
    x1: 227.84,
    y1: 47.6379,
    x2: 233.245,
    y2: 44.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#513E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#513E5F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4330_50313",
    x1: 328.718,
    y1: -9.65019,
    x2: 326.246,
    y2: -8.21907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#474646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474646",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4330_50313",
    x1: 342.605,
    y1: 31.4446,
    x2: 332.279,
    y2: 37.4228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4330_50313",
    x1: 338.399,
    y1: -1.56717,
    x2: 379.755,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4330_50313",
    x1: 338.399,
    y1: -1.56717,
    x2: 379.755,
    y2: 70.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FAD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4330_50313",
    x1: 300.521,
    y1: 48.7671,
    x2: 400.921,
    y2: -9.34695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D476D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3D3B3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4330_50313",
    x1: 299.867,
    y1: 47.6379,
    x2: 305.272,
    y2: 44.5094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#513E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#513E5F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4330_50313",
    x1: 400.746,
    y1: -9.65019,
    x2: 398.273,
    y2: -8.21907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#474646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474646",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopImgCards);
export default __webpack_public_path__ + "static/media/top-img-cards.596bdb0762960f89fc71dd46d90accf0.svg";
export { ForwardRef as ReactComponent };